const logoutChannel = new BroadcastChannel('logout_channel');

export default logoutChannel;